import { KeenSliderInstance, KeenSliderPlugin } from 'keen-slider/react'

import { MutableRefObject } from 'react'

import { MAX_PDP_DOTS } from './constant'
import { DotsType } from './types'

export const getVisiblePdpDots = (dotsType: DotsType, dotsArray: number[], currentSlide: number): number[] => {
    let startIndex = 0
    let endIndex = dotsArray.length

    if (dotsType !== DotsType.PDP) return dotsArray

    if (dotsArray.length > MAX_PDP_DOTS) {
        const centerPosition = Math.floor(MAX_PDP_DOTS / 2)
        const maxStartIndex = dotsArray.length - MAX_PDP_DOTS

        startIndex = currentSlide - centerPosition
        startIndex = Math.max(0, Math.min(startIndex, maxStartIndex))
        endIndex = startIndex + MAX_PDP_DOTS
    }

    return dotsArray.slice(startIndex, endIndex)
}

export function ThumbnailPlugin(mainRef: MutableRefObject<KeenSliderInstance | null>): KeenSliderPlugin {
    return (slider) => {
        function removeActive() {
            slider.slides.forEach((slide) => {
                slide.classList.remove('active')
            })
        }
        function addActive(idx: number) {
            slider.slides[idx].classList.add('active')
        }

        function addClickEvents() {
            slider.slides.forEach((slide, idx) => {
                slide.addEventListener('click', () => {
                    if (mainRef.current) mainRef.current.moveToIdx(idx)
                })
            })
        }

        slider.on('created', () => {
            if (!mainRef.current) return
            addActive(slider.track.details.rel)
            addClickEvents()
            mainRef.current.on('animationStarted', (main) => {
                removeActive()
                const next = main.animator.targetIdx || 0
                addActive(main.track.absToRel(next))
                slider.moveToIdx(Math.min(slider.track.details.maxIdx, next))
            })
        })
    }
}
